import type { ProviderPriceListModel, ServiceProductModel } from '@models/types'
import { EntitiesState } from '@redux/entities'

import autoSelectProductOptions from '@functions/autoSelectProductOptions'
import filterPriceListItemsByPriceListAndProduct from '@functions/filterPriceListItemsByPriceListAndProduct'

type AutoSelectProductQuantityAndOptionsParams = {
  providerPriceList: ProviderPriceListModel | {},
  providerPriceListItemOptionValues: EntitiesState['providerPriceListItemOptionValues'],
  providerPriceListItemOptions: EntitiesState['providerPriceListItemOptions'],
  providerPriceListItems: EntitiesState['providerPriceListItems'],
  serviceProduct: ServiceProductModel,
}

function autoSelectProductQuantityAndOptions(params: AutoSelectProductQuantityAndOptionsParams) {
  const {
    providerPriceList,
    providerPriceListItemOptionValues,
    providerPriceListItemOptions,
    providerPriceListItems,
    serviceProduct,
  } = params

  const filteredPriceListItems = filterPriceListItemsByPriceListAndProduct({
    providerPriceList,
    providerPriceListItems,
    serviceProduct,
  })

  const firstPriceListItem = filteredPriceListItems[0]

  const { selectedProviderPriceListItemOptions } = autoSelectProductOptions({
    providerPriceListItem: firstPriceListItem,
    providerPriceListItemOptionValues,
    providerPriceListItemOptions,
  })

  return { firstPriceListItem, selectedProviderPriceListItemOptions }
}

export default autoSelectProductQuantityAndOptions
